export default __webpack_public_path__ + "static/Graphik-Bold-Web-de8ca5182550ebaeec2a065ca55eeef3.woff";